var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorkflows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.811 7.5C11.1449 10.0878 8.79576 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C8.79576 0 11.1449 1.91216 11.811 4.5H22.5854C22.3993 3.97234 22.5173 3.36138 22.9393 2.93934C23.5251 2.35355 24.4749 2.35355 25.0607 2.93934L27.0607 4.93934C27.6464 5.52513 27.6464 6.47487 27.0607 7.06066L25.0607 9.06066C24.4749 9.64645 23.5251 9.64645 22.9393 9.06066C22.5173 8.63862 22.3993 8.02766 22.5854 7.5H11.811ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 12C38.3137 12 41 9.31371 41 6C41 2.68629 38.3137 0 35 0C31.6863 0 29 2.68629 29 6C29 7.49872 29.5495 8.8691 30.458 9.92066L20.5505 19.8282C20.309 19.3235 19.7936 18.9749 19.1967 18.9749C18.3683 18.9749 17.6967 19.6464 17.6967 20.4749V23.3033C17.6967 24.1317 18.3683 24.8033 19.1967 24.8033H22.0251C22.8536 24.8033 23.5251 24.1317 23.5251 23.3033C23.5251 22.7064 23.1765 22.191 22.6718 21.9495L32.9725 11.6488C33.6058 11.8761 34.2884 12 35 12ZM35 9C36.6569 9 38 7.65685 38 6C38 4.34315 36.6569 3 35 3C33.3431 3 32 4.34315 32 6C32 7.65685 33.3431 9 35 9Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.811 31.5C18.1449 34.0878 15.7958 36 13 36C9.68629 36 7 33.3137 7 30C7 26.6863 9.68629 24 13 24C15.7958 24 18.1449 25.9122 18.811 28.5H29.5854C29.3993 27.9723 29.5173 27.3614 29.9393 26.9393C30.5251 26.3536 31.4749 26.3536 32.0607 26.9393L34.0607 28.9393C34.6464 29.5251 34.6464 30.4749 34.0607 31.0607L32.0607 33.0607C31.4749 33.6464 30.5251 33.6464 29.9393 33.0607C29.5173 32.6386 29.3993 32.0277 29.5854 31.5H18.811ZM16 30C16 31.6569 14.6569 33 13 33C11.3431 33 10 31.6569 10 30C10 28.3431 11.3431 27 13 27C14.6569 27 16 28.3431 16 30Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 36C45.3137 36 48 33.3137 48 30C48 26.6863 45.3137 24 42 24C38.6863 24 36 26.6863 36 30C36 33.3137 38.6863 36 42 36ZM42 33C43.6569 33 45 31.6569 45 30C45 28.3431 43.6569 27 42 27C40.3431 27 39 28.3431 39 30C39 31.6569 40.3431 33 42 33Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorkflows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/workflows.cedc03df2c4ddceae9ff5849d97d7bdd.svg";